export enum StepName {
  MobileAccountLookup = "MobileAccountLookup",
  CashAccepter = "CashAccepter",
  PrintReceipt = "PrintReceipt",
  EmailAddress = "EmailAddress",
  Farewell = "Farewell",
  ApplicationSelect ="ApplicationSelect",
}
